import React from 'react'
//import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CImage,
	CForm,
	CButton,
	CFormInput,
	CInputGroup,
	CLink,
	CTooltip,
	CDropdown, CDropdownItem, CDropdownToggle, CDropdownMenu,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { Konfirm } from '../../helpers/onConfirm'
//import { UFunc } from '../../helpers/functions'

const pjson 	= require('../../../package.json')
const Headersubstokopname = (props) => {
	//const { setToken,setLoading, showToast } = props 

	//--DOM--/
	//const uNavigate 			= useNavigate()
	const uDispatch 			= useDispatch()
	//--END DOM--/

	const uHeaderActionObj  	= useSelector(state => state.gInitHeaderAction)
	const uBahasaObj  			= useSelector(state => state.listBahasa)
	const uActiveroute			= useSelector(state => state.activeRoute)
	const uKeywordObj			= JSON.parse(localStorage.getItem("listkeyword")) || {};
	//const uTokenObj				= JSON.parse(localStorage.getItem("token")||"{}");
	const uEfekapp				= useSelector(state => state.effectApp);
	
	const [uInpkeyword,setInpkeyword]= React.useState(uKeywordObj.kwd_stokurgent||"");

	const hdlKeydown = (_EV) => {
		if(_EV.which===13) {
			_EV.stopPropagation();
			_EV.preventDefault();
			document.getElementById("btnCari").click();
		}//-*/
	}
	const hdlKlikCari = () => {
		//---SAVE_KEYWORD--/
		uKeywordObj.kwd_stokurgent = uInpkeyword.trim(); 
    	localStorage.setItem("listkeyword",JSON.stringify(uKeywordObj));
		//---END SAVE_KEYWORD--/

		uHeaderActionObj.isHeaderView = true;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
		uDispatch({type: "set", effectApp: !uEfekapp});
	}
	const hdlKlikTambah = () => {
		//console.log("Headersubstokopname - hdlKlikTambah uHeaderActionObj => "+JSON.stringify(uHeaderActionObj));
		uHeaderActionObj.isHeaderTambah = true;//!(vHeaderTmpObj.isHeaderTambah||false);
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
		uDispatch({type: "set", effectApp: !uEfekapp});
	}
	const hdlKlikReset = async() => {
		const vProses = () => {
			//---CLEAR_KEYWORD--/
			uKeywordObj.kwd_stokurgent = undefined; 
	    	localStorage.setItem("listkeyword",JSON.stringify(uKeywordObj));
	    	setInpkeyword("");
			//---END CLEAR_KEYWORD--/
			
			//setHeaderView(true);
			uHeaderActionObj.isHeaderView = true;
			uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
			uDispatch({type: "set", effectApp: !uEfekapp});
		}

		if((uInpkeyword||"") !== "") {
			if(await Konfirm(uBahasaObj.confirm_reset||"Apakah Yakin Akan Direset ?")) vProses();
		} else vProses();	
	}

	//console.log("Headersubstokopname - uActiveroute => "+(uActiveroute));
	return (
		<>
		<div className="d-none d-lg-block">
		<CImage src={pjson.homepage+"api/images/menus_"+(uActiveroute||"").toLowerCase()+".png"} 
			className="me-2"
			height={30}/>
		<small>{uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]||""}</small>
		</div>

		<div className="d-flex align-items-center mx-auto mx-lg-0">
			<CForm className="">
			<CInputGroup size="sm">
			<CFormInput size="sm" 
				value={uInpkeyword} 
				onChange={(e) => setInpkeyword(e.target.value)} 
				onKeyDown={(e) => hdlKeydown(e)} 
				style={{minWidth:270,width:"auto"}} 
				placeholder={"--"+(uBahasaObj.petunjuk_keyword||"Masukkan uKeyword")+".."} 
				id="inpkeyword"/>
			<CButton type="button" color="secondary" onClick={()=>hdlKlikCari()} id="btnCari" className="py-0">
				<CIcon icon="cilMagnifyingGlass" className="text-white" />
			</CButton>
			</CInputGroup>
			</CForm>
			<span className="mx-1 d-none d-lg-block">&middot;</span>

			<CTooltip content={"--"+(uBahasaObj.caption_inputstokopname||"Input Stok Opname")}>
			<CLink onClick={()=>hdlKlikTambah()} className="d-none d-md-block classikon classikontambah classcursorpointer" />
			</CTooltip>

			<span className="d-none d-lg-block me-1">&middot;</span>
			
			<CTooltip content={"--"+(uBahasaObj.caption_resetdata||"Reset View Tampilan")}>
			<CLink onClick={()=>hdlKlikReset()} className="d-none d-md-block classikon classikonreset classcursorpointer" />
			</CTooltip>
				
			<span className="me-2 d-none d-md-block">&middot;</span>
			<span className="d-none d-md-block">
			<b id="idjmldata" className="text-primary">0</b>{" "}{uBahasaObj.word_data||"Data"}
			</span>

			<CDropdown className="d-md-none ms-1">
				<CDropdownToggle caret={false} size="sm" className="p-0"
					color="transparent">
					<CIcon icon="cilChevronBottom" className="classikonbox ms-0 me-2" height={30}/>
				</CDropdownToggle>
				<CDropdownMenu>
				<CDropdownItem onClick={()=>hdlKlikTambah()}>
					<CIcon className="classikontambah ms-0 me-2 align-middle" height={25}/>
					{uBahasaObj.caption_resetdata||"Input Stok Opname"}
				</CDropdownItem>
				<CDropdownItem onClick={()=>hdlKlikReset()}>
					<CIcon className="classikonreset ms-0 me-2 align-middle" height={25}/>
					{uBahasaObj.caption_resetdata||"Reset Tampilan"}
				</CDropdownItem>
				</CDropdownMenu>
			</CDropdown>			
		</div>
		</>
	)
}

export default Headersubstokopname
